import api from "./api";

export const fetchMarketingHome = () => api.get("/marketing/home/");
